import React from 'react';
import { Flex } from 'antd';
import { Heading } from '../Heading';
import { useTranslation } from 'react-i18next';
import { Card } from '../Card';

interface StickyFooterProps {
  /**
   * The main action button to be displayed
   */
  actionButton?: React.ReactNode;
  /**
   * Additional content to be displayed in the footer
   */
  additionalContent?: React.ReactNode;
  /**
   * Custom className for the footer container
   */
  className?: string;
  /**
   * Custom className for the card component
   */
  cardClassName?: string;
}

/**
 * A sticky footer component that remains fixed at the bottom of the page
 * Can be used for forms, modals, or any other content that needs a persistent footer
 */
const StickyFooter: React.FC<StickyFooterProps> = ({
  actionButton,
  additionalContent,
  className = '',
  cardClassName = '',
}) => {
  return (
    <div className={`sticky bottom-0 ${className}`}>
      {/*// ! bottom-0 => should be aligned with sidebar */}
      <Card extraClassName={`py-4 shadow-lg ${cardClassName}`} noMargin>
        <Flex gap='middle' justify={additionalContent ? 'space-between' : 'end'} align='center'>
          {additionalContent}
          {actionButton}
        </Flex>
      </Card>
    </div>
  );
};

export default StickyFooter;
